import {Project} from './project';
import {Client} from './client';
import {Fournisseur} from './fournisseur';
import {Entrepot} from './entrepot';

export interface ClientData {
    nom_client: string;
    identifiant_unique?: string;
    numero_identification_fiscale?: string;
    adresse?: string;
    email?: string;
    telephone?: string;
    client_id?: number;
}

export interface FournisseurData {
    fournisseur_id: number;
    nom_entreprise: string;
    numero_identification_fiscale?: string;
    responsable?: string;
    phone?: string;
    adresse?: string;
    email?: string;
}

export interface AjoutLigne {
    contenu_text: string;
    rubrique: string;
    separateur: boolean;
    sous_total: number;
    order: number;
}

export interface LigneDocumentPayload {
    libelle: string;
    qnt: number;
    unite?:string;
    remise?: string | number;
    prix_ht: number | string;
    tva: number;
    product_id?: number | null;
    /** Métadonnées ligne (persistées côté API). */
    code_bar?: string | null;
    ref_interne?: string | null;
    couleur?: string | null;
    taille?: string | null;
    ajout_ligne?: AjoutLigne[];
    type_ligne?: 'product' | 'text' | 'heading' | 'separator' | 'subtotal';
}
export interface EntreprisePayload {
    nom_entreprise: string;
    adresse?: string;
    matricule_fiscale?: string;
}

/** Snapshot bancaire attaché au document (≠ compte paramètre Banque). */
export interface CoordonneeBancairePayload {
    nom: string;
    rib: string;
    banque?: string | null;
    agence?: string | null;
}

export interface TypeDocument {
    id?: number;
    titre?: string;
    description?: string;
    created_at?: string;
    updated_at?: string;
}
export interface Statut {
    id?: number;
    titre?: string;
    description?: string;
    couleur?: string;
    created_at?: string;
    updated_at?: string;
}
export interface ProjetPivot {
    id_projet: string;
    titre: string;
}

/**
 * Enum pour les fréquences de date d'échéance
 */
export enum DateEcheanceFrequency {
    JOURS = 'jours',
    MOIS = 'mois',
    ANNEE = 'annee'
}

export interface ParametrageDoc {
    aff_montant_ttc?: boolean;
    aff_code_bar?: boolean;
    aff_date_echeance?: boolean;
    aff_date_liv?: boolean;
    aff_montant_total?: boolean;
    aff_coordonnees?: boolean;
    reference?: boolean;
    quantite?: boolean;
    unite?: boolean;
    prix_unitaire?: boolean;
    tva?: boolean;
    remise?: boolean;
    color?: string; // Couleur primaire du document
    label?: string; // Label du document
    date_echeance?: DateEcheanceFrequency; // Fréquence sélectionnée: jours, mois, ou annee
    nbr_date?: number; // Nombre de jours/mois/années pour la date d'échéance
}

export interface DocumentPayload {
    id?: number;
    ref_externe?: string;
    /** Référence interne (alignée sur ref_externe / compteur API ref-counter côté backend). */
    ref_interne?: string;
    date: string;
    date_livraison?: string | null;
    note?: string;
    total_ht: string;
    total_tva: string;
    total_ttc: string;
    timbre_fiscal: string;
    net_payer: string;
    user_id: number;
    station_id: number;
    /** Établissement LC (etablissements.id) → documents.etablissement_id ERP. */
    etablissement_id?: number | null;
    type_document_id: number;
    statut_id: number;
    /** Modèle de référence (reference_model_config) : types 1…6+ selon l’API (ex. préfixe-seul, année-séquence, …) */
    reference_model_type?: number | null;
    created_at?: string;
    updated_at?: string;
    date_echeance?: string;
    nbr_date?: number;
    color?: any;
    label?: string;
    client_id?: number | null;
    projet_id?: number | null;
    fournisseur_id?: number | null;
    entrepot_id?: number | null;
    /** Bon de transfert : entrepôt de destination (complète entrepot_id = source). */
    entrepot_dest_id?: number | null;
    /** Pour un avoir : ID du document facture d'origine */
    document_original_id?: number | null;
    typeDocument?: TypeDocument[];
    statut?:Statut[];
    client_data?: {
        nom_client: string;
        identifiant_unique?: string;
        numero_identification_fiscale?: string;
        adresse?: string;
        email?: string;
        telephone?: string;
    };
    fornisseur_data?: {
    nom_entreprise: string;
    numero_identification_fiscale?: string;
    responsable?: string;
    phone?: string;
    adresse?: string;
    email?: string;
};
    projet_data?: {
        titre: string;
        libelle?: string;
    };
    clients?: ({ id: number } | Client | ClientData)[];
    fornisseurs?: ({ id: number } | Fournisseur | FournisseurData)[];
    projets?: ({ id: number } | Project | ProjetPivot)[];
    lignes_document: LigneDocumentPayload[];
    entreprises?: EntreprisePayload[];
    coordonnees_bancaires?: CoordonneeBancairePayload[];
    entrepot?: Entrepot;
    
    // Paramètres d'affichage du document (regroupés dans parametrage_doc)
    parametrage_doc?: ParametrageDoc;
    
    // Paramètres d'affichage du document (ancien format - pour compatibilité)
    aff_montant_ttc?: boolean;
    aff_code_bar?: boolean;
    aff_date_echeance?: boolean;
    aff_date_liv?: boolean;
    aff_montant_total?: boolean;
    aff_coordonnees?: boolean;
    reference?: boolean;
    quantite?: boolean;
    unite?: boolean;
    prix_unitaire?: boolean;
    tva?: boolean;
    remise?: boolean;

    hidden_client_fields?: {
        nomClient?: boolean;
        identifiant?: boolean;
        numeroIdentification?: boolean;
        adresse?: boolean;
        email?: boolean;
    };
    hidden_fournisseur_fields?: {
        nomEntreprise?: boolean;
        numeroIdentification?: boolean;
        responsable?: boolean;
        telephone?: boolean;
        adresse?: boolean;
    };
}

export interface DocumentResponse {
    success?: boolean;
    message?: string;
    data?: {
        document?: DocumentPayload & {
            entrepot_id?: number | null;
            entrepot?: Entrepot;
        };
    };
}
